import React, {useEffect} from "react";
import KiranImg from "../../assets/Banner.webp"; // Replace with real image paths
import RaviImg from "../../assets/Banner.webp";
import AkshayImg from "../../assets/Banner.webp";
import bg from "../../assets/internalImages/Enterprise/_wocs_bg.webp";

const testimonials = [
  {
    img: KiranImg,
    name: "Kiran Dixit",
    role: "General Store Owner",
    text: "With recurring orders, I just set it once and forget. Milk and grocery reach my retail partners every morning without fail. Packky(powered by Chaafo) has become a daily part of how I run my business.",
  },
  {
    img: RaviImg,
    name: "Ravi Mishra",
    role: "Distribution Manager, GroFast",
    text: "Packky (powered by Chaafo) helped us scale our FMCG delivery across 12 stores without hiring our own fleet. The platform gave us complete control over logistics, and we now manage more deliveries with less operational overhead.",
  },
  {
    img: AkshayImg,
    name: "Akshay Sharma",
    role: "Logistics Head, B2B Pharma",
    text: "The dashboard helps us manage vendors and track all shipments in one place. It’s made our pharma deliveries more transparent and saved hours of coordination.",
  },
];

const ClientReviews = () => {
  return (
    <div
      className="container-fluid py-5"
      style={{
        backgroundImage: `url(${bg})`,
        // background: "linear-gradient(to bottom, #fcebdb, #f7bd82)",
      }}
    >
      <div className="container">
        <h2 className="fw-bold text-start mb-2" style={{ color: "#1d1d1d" }}>
          What Our Clients Say
        </h2>
        <p className="text-start text-secondary mb-4">
          From small stores to growing enterprises, our clients share their experience.
        </p>

        <div className="row justify-content-center mt-5 pt-2">
          {testimonials.map((client, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4 mb-4 d-flex">
              <div
                className="card p-4 shadow-sm w-100"
                style={{ borderRadius: "16px", background: 'rgba(255, 255, 255, 0.45)', border: '1px solid white'}}
              >
                <div className="d-flex align-items-center mb-3">
                  <img
                    src={client.img}
                    alt={client.name}
                    width="50"
                    height="50"
                    className="rounded-circle me-3"
                  />
                  <div>
                    <h6 className="mb-0 fw-bold">{client.name}</h6>
                    <small className="text-muted">{client.role}</small>
                  </div>
                </div>
                <p className="text-dark" style={{ fontWeight: "400", fontSize: "14px" }}>
                  “{client.text}”
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientReviews;
